export class Lightware {
    constructor(socket, log) {
        this.socket = socket;
        this.audioFollowsOutput = '1';
        this.audioInputs = [];
        this.audioOutputRoutes = [];
        this.audioOutputs = [];
        this.firmwareVersion = '1.3.14 r15';
        this.serialNumber = '12345678';
        this.usbFollowsOutput = '1';
        this.usbOutputRoutes = [];
        this.videoOutputs = [];
        this.audioControls = {
            '-O45rfxbX7MEjS3XjRDL': {
                name: 'UXC-4x3-TPX-TX20',
                numAudioOutputs: 1,
            },
            '-O45rtpyhmQgodoFD36Q': {
                name: 'UXC-2x1-TPX-TX20',
                numAudioOutputs: 1,
            },
            '-NmhIhicf3yUUhVHRoiz': {
                name: 'UXC-2x1-HC30',
                numAudioOutputs: 1,
            },
            '-Nmq6GE3pW2kAKBfIA2h': {
                name: 'UXC-4x3-HC40',
                numAudioOutputs: 1,
            },
            '-Ntv3Sj67fTq4A2V_29Q': {
                name: 'UXC-4x2-HC40',
                numAudioOutputs: 1,
            },
            '-MWioBRNG33X6RLej79n': {
                name: 'UXC4x2-HC30',
                numAudioOutputs: 3,
            },
            '-MWioFpGIAVocTaOQvRD': {
                name: 'UXC4x2-HC30D',
                numAudioOutputs: 3,
            },
            '-MKL0UJNMS-yBoeWcuNv': {
                name: 'MMX4x2-HDMI',
                numAudioOutputs: 3,
            },
            '-MKL0ahLpNhJFXoe0fzL': {
                name: 'MMX4x2-HT200',
                numAudioOutputs: 3,
            },
            '-MKL0dTMMJE70eWIn_Cq': {
                name: 'MMX6x2-HT200 / 210 / 220"',
                numAudioOutputs: 6,
            },
            '-MKL0gLW-ryO-GGNVGKf': {
                name: 'MMX8x4-HT400MC',
                numAudioOutputs: 6,
            },
            '-MKL0jfOqmJgkwfB9f4p': {
                name: 'MMX8x4-HT420M',
                numAudioOutputs: 6,
            },
            '-MKL0n_swllwolmpNUcl': {
                name: 'MMX8x8-HDMI-4K-A',
                numAudioOutputs: 8,
            },
        };
        this.asyncHandlers = [
            {
                name: 'autoSwitch',
                regExp: /CALL \/MEDIA\/VIDEO\/XP:setDestinationPortAutoselect\(.+\)/i,
                callback: (match) => {
                    this.socket.send(`mO /MEDIA/VIDEO/XP:setDestinationPortAutoselect`);
                },
            },
            {
                name: 'firmwareVersion',
                regExp: /GET\s+\/SYS\/MB\.FirmwareVersion/i,
                callback: (match) => {
                    this.socket.send(`pr /SYS/MB.FirmwareVersion=${this.firmwareVersion}`);
                },
            },
            {
                name: 'firmwareVersionMx2',
                regExp: /GET\s+\/MANAGEMENT\/UID\.FirmwareVersion/i,
                callback: (match) => {
                    this.socket.send(`pr /MANAGEMENT/UID.FirmwareVersion=${this.firmwareVersion}`);
                },
            },
            {
                name: 'firmwareVersionUcx',
                regExp: /GET\s+\/V1\/MANAGEMENT\/UID\/PACKAGE.Version/i,
                callback: (match) => {
                    this.socket.send(`pr /V1/MANAGEMENT/UID/PACKAGE.Version=v${this.firmwareVersion}`);
                },
            },
            {
                name: 'muteQuery',
                regExp: /GET \/MEDIA\/AUDIO\/XP.DestinationPortStatus/i,
                callback: (match) => {
                    const responseString = this.createAudioStatus();
                    this.socket.send(`pr /MEDIA/AUDIO/XP.DestinationPortStatus=${responseString}`);
                },
            },
            {
                name: 'muteQueryUcx',
                regExp: /GET \/V1\/MEDIA\/AUDIO\/XP\/O(\d+).Mute/i,
                callback: (match) => {
                    const audioOutputNum = parseInt(match[1], 10) - 1;
                    const valueStr = this.audioOutputs[audioOutputNum].mute ? 'true' : 'false';
                    this.socket.send(`pw /V1/MEDIA/AUDIO/XP/O${audioOutputNum + 1}.Mute=${valueStr}`);
                },
            },
            {
                name: 'muteSet',
                regExp: /CALL \/MEDIA\/AUDIO\/XP:(mute|unmute)Destination\(O(.+)\)/i,
                callback: (match) => {
                    const outputNum = parseInt(match[2], 10) - 1;
                    this.audioOutputs[outputNum].mute = match[1] === 'mute' ? true : false;
                    this.socket.send(`mO /MEDIA/AUDIO/XP:${match[1]}Destination`);
                },
            },
            {
                name: 'muteSetUcxInput',
                regExp: /SET \/V1\/MEDIA\/AUDIO\/XP\/I(\d+).Mute=(true|false)/i,
                callback: (match) => {
                    const inputNum = parseInt(match[1], 10) - 1;
                    this.audioInputs[inputNum].mute = match[2] === 'true';
                    const valueStr = this.audioInputs[inputNum].mute ? 'true' : 'false';
                    this.socket.send(`pw /V1/MEDIA/AUDIO/XP/I${inputNum + 1}.Mute=${valueStr}`);
                },
            },
            {
                name: 'muteSetUcxOutput',
                regExp: /SET \/V1\/MEDIA\/AUDIO\/XP\/O(\d+).Mute=(true|false)/i,
                callback: (match) => {
                    const outputNum = parseInt(match[1], 10) - 1;
                    this.audioOutputs[outputNum].mute = match[2] === 'true';
                    const valueStr = this.audioOutputs[outputNum].mute ? 'true' : 'false';
                    this.socket.send(`pw /V1/MEDIA/AUDIO/XP/O${outputNum + 1}.Mute=${valueStr}`);
                },
            },
            {
                name: 'audioQueryUxc',
                regExp: /GET \/V\d+\/MEDIA\/AUDIO\/XP\/O(\d+).ConnectedSource/i,
                callback: (match) => {
                    const outputNum = parseInt(match[1], 10) - 1;
                    const src = this.audioOutputRoutes[outputNum];
                    this.socket.send(`pw /V1/MEDIA/AUDIO/XP/O${outputNum + 1}.ConnectedSource=I${src}`);
                },
            },
            {
                name: 'serialNumber',
                regExp: /GET\s+\/\.SerialNumber/i,
                callback: (match) => {
                    this.socket.send(`pr /.SerialNumber=${this.serialNumber}`);
                },
            },
            {
                name: 'subscribeAudio',
                regExp: /OPEN (\/V\d+)?\/MEDIA\/AUDIO\/XP$/i,
                callback: (match) => {
                    var _a;
                    this.socket.send(`o- ${(_a = match[1]) !== null && _a !== void 0 ? _a : ''}/MEDIA/AUDIO/XP`);
                },
            },
            {
                name: 'subscribeAudioUcx',
                regExp: /OPEN (\/V\d+)?\/MEDIA\/AUDIO\/([OI]\d+)/i,
                callback: (match) => {
                    var _a;
                    this.socket.send(`o- ${(_a = match[1]) !== null && _a !== void 0 ? _a : ''}/MEDIA/AUDIO/${match[2]}`);
                },
            },
            {
                name: 'subscribeAudioXpUcx',
                regExp: /OPEN (\/V\d+)?\/MEDIA\/AUDIO\/XP\/([OI]\d+)/i,
                callback: (match) => {
                    var _a;
                    this.socket.send(`o- ${(_a = match[1]) !== null && _a !== void 0 ? _a : ''}/MEDIA/AUDIO/XP/${match[2]}`);
                },
            },
            {
                name: 'subscribeVideo',
                regExp: /OPEN (\/V\d+)?\/MEDIA\/(VIDEO\/XP|XP\/VIDEO)/i,
                callback: (match) => {
                    var _a;
                    this.socket.send(`o- ${(_a = match[1]) !== null && _a !== void 0 ? _a : ''}/MEDIA/${match[2]}`);
                },
            },
            {
                name: 'usbSetRoute',
                regExp: /SET \/MEDIA\/USB\/USBSWITCH.HostSelect=(\d+)/i,
                callback: (match) => {
                    // USB switching is associated with output '1'
                    this.usbOutputRoutes[0] = match[1];
                    this.socket.send(`pw /MEDIA/USB/USBSWITCH.HostSelect=${match[1]}`);
                },
            },
            {
                name: 'videoQueryRoute',
                regExp: /GET \/MEDIA\/(VIDEO\/XP|XP\/VIDEO)\.DestinationConnection(List|Status)/i,
                callback: (match) => {
                    const inputsToOutputs = this.videoOutputs.map(o => `I${o}`).join(';');
                    this.socket.send(`pr /MEDIA/${match[1]}.DestinationConnection${match[2]}=${inputsToOutputs}`);
                },
            },
            {
                name: 'videoSetRoute',
                regExp: /CALL (\/V\d+)?\/MEDIA\/(VIDEO\/XP|XP\/VIDEO):switch\(I(\d+):O(\d+)\)/i,
                callback: (match) => {
                    var _a, _b, _c, _d;
                    const outputNum = parseInt(match[4], 10) - 1;
                    const prevInput = (_a = this.videoOutputs[outputNum]) !== null && _a !== void 0 ? _a : '1';
                    const newInput = match[3];
                    const root = (_b = match[1]) !== null && _b !== void 0 ? _b : '';
                    const prefix = `${root}/MEDIA/${match[2]}`;
                    if (match[1]) {
                        this.videoOutputs[outputNum] = newInput !== null && newInput !== void 0 ? newInput : '1';
                        let dest = this.createDestinations(newInput, this.videoOutputs, 'O');
                        this.socket.send(`CHG ${prefix}/I${newInput}.ConnectedDestinations=${dest}`);
                        dest = this.createDestinations(prevInput, this.videoOutputs, 'O');
                        this.socket.send(`CHG ${prefix}/I${prevInput}.ConnectedDestinations=${dest}`);
                        this.socket.send(`CHG ${prefix}/O${outputNum + 1}.ConnectedSource=I${newInput}`);
                    }
                    this.socket.send(`mO ${prefix}:switch${match[1] ? '=' : ''}`);
                    if (this.audioFollowsOutput === match[4] && this.audioOutputs.length > 0) {
                        const prevAudioInput = (_c = this.audioOutputRoutes[outputNum]) !== null && _c !== void 0 ? _c : '1';
                        this.audioOutputRoutes[outputNum] = newInput !== null && newInput !== void 0 ? newInput : '1';
                        let dest = this.createDestinations(newInput, this.audioOutputRoutes, 'O');
                        this.socket.send(`CHG ${root}/MEDIA/AUDIO/XP/I${newInput}.ConnectedDestinations=${dest}`);
                        dest = this.createDestinations(prevAudioInput, this.audioOutputRoutes, 'O');
                        this.socket.send(`CHG ${root}/MEDIA/AUDIO/XP/I${prevAudioInput}.ConnectedDestinations=${dest}`);
                    }
                    // For Taurus products, if the USB switching is mapped to this output, update USB
                    // routes.
                    if (match[1] && this.usbFollowsOutput === match[4]) {
                        const currentUsbInput = (_d = this.usbOutputRoutes[outputNum]) !== null && _d !== void 0 ? _d : '1';
                        this.usbOutputRoutes[outputNum] = newInput;
                        let dest = this.createDestinations(newInput, this.usbOutputRoutes, 'H');
                        this.socket.send(`CHG ${root}/MEDIA/USB/XP/U${newInput}.ConnectedDestinations=${dest}`);
                        dest = this.createDestinations(currentUsbInput, this.usbOutputRoutes, 'H');
                        this.socket.send(`CHG ${root}/MEDIA/USB/XP/U${currentUsbInput}.ConnectedDestinations=${dest}`);
                    }
                },
            },
            {
                name: 'volumeQuery',
                regExp: /GET (\/V\d+)?\/MEDIA\/AUDIO\/O(\d+)\.Volume(dB)*/i,
                callback: (match) => {
                    var _a;
                    const root = (_a = match[1]) !== null && _a !== void 0 ? _a : '';
                    const outputNum = parseInt(match[2], 10) - 1;
                    const db = match[3] ? 'dB' : '';
                    const volume = this.audioOutputs[outputNum].volume;
                    this.socket.send(`pw ${root}/MEDIA/AUDIO/O${match[2]}.Volume${db}=${volume}`);
                },
            },
            {
                name: 'videoQueryUcx',
                regExp: /GET \/V\d+\/MEDIA\/VIDEO\/XP\/O(\d+).ConnectedSource/i,
                callback: (match) => {
                    const outputNum = parseInt(match[1], 10) - 1;
                    this.socket.send(`pw /V1/MEDIA/VIDEO/XP/O${match[1]}.ConnectedSource=I${this.videoOutputs[outputNum]}`);
                },
            },
            {
                name: 'volumeSet',
                regExp: /SET \/MEDIA\/AUDIO\/O(\d+).Volume(dB)*=(-?[\d\.]+)/i,
                callback: (match) => {
                    const outputNum = parseInt(match[1], 10) - 1;
                    const db = match[2] ? 'dB' : '';
                    const volume = parseInt(match[3], 10);
                    this.audioOutputs[outputNum].volume = volume;
                    this.socket.send(`pw /MEDIA/AUDIO/O${match[1]}.Volume${db}=${volume}`);
                },
            },
            {
                name: 'volumeSetUcx',
                regExp: /SET \/V1\/MEDIA\/AUDIO\/O(\d+).Volume(dB)?=(-?[\d\.]+)/i,
                callback: (match) => {
                    const outputNum = parseInt(match[1], 10) - 1;
                    const db = match[2] ? 'dB' : '';
                    const volume = parseInt(match[3], 10);
                    this.audioOutputs[outputNum].volume = volume;
                    this.socket.send(`pw /V1/MEDIA/AUDIO/O${match[1]}.Volume${db}=${volume}`);
                },
            },
            {
                name: 'invalid',
                regExp: /(.+)/i,
                callback: (match) => {
                    this.socket.send(`-E ${match[1]} %E001: Syntax error`);
                },
            },
        ];
        const maxAudioOutputs = Object.values(this.audioControls).reduce((prev, curr) => {
            return prev > curr.numAudioOutputs ? prev : curr.numAudioOutputs;
        }, 0);
        this.audioOutputs.length = maxAudioOutputs;
        this.audioOutputs.fill({
            volume: -30,
            mute: false,
            lock: false,
            present: false,
            connected: false,
        });
    }
    onConfigure(config) {
        var _a, _b;
        const maxVideoOutputs = Object.values((_a = config.videoOutputs) !== null && _a !== void 0 ? _a : {}).reduce((prev, curr) => {
            const num = parseInt(curr.code, 10);
            return prev > num ? prev : num;
        }, 1);
        const videoInputCodes = Object.values((_b = config.videoInputs) !== null && _b !== void 0 ? _b : {}).reduce((prev, curr) => {
            if (!prev.includes(curr.code))
                prev.push(curr.code);
            return prev;
        }, []);
        if (videoInputCodes.length === 0)
            videoInputCodes.push('1');
        if (maxVideoOutputs > this.videoOutputs.length)
            this.videoOutputs.length = maxVideoOutputs;
        for (let i = 0; i < this.videoOutputs.length; i++) {
            if (this.videoOutputs[i] === undefined ||
                !videoInputCodes.includes(this.videoOutputs[i])) {
                this.videoOutputs[i] = videoInputCodes[0];
            }
        }
    }
    // other class methods
    createDestinations(inputName, routes, type) {
        return routes
            .map((r, i) => [r, `${type}${i + 1}`])
            .filter(([r, n]) => r === inputName)
            .map(([r, n]) => n)
            .join(';');
    }
    createAudioStatus() {
        const values = [];
        for (const audioOutput of this.audioOutputs) {
            let value = '';
            // channel mute and lock status
            if (audioOutput.mute && audioOutput.lock) {
                value += 'U';
            }
            else if (audioOutput.mute && !audioOutput.lock) {
                value += 'M';
            }
            else if (!audioOutput.mute && audioOutput.lock) {
                value += 'L';
            }
            else {
                value += 'T';
            }
            // reserved characters
            value += '000';
            // signal preseence information
            if (audioOutput.present && audioOutput.connected) {
                value += 'F';
            }
            else if (!audioOutput.present && audioOutput.connected) {
                value += 'B';
            }
            else {
                value += 'A';
            }
            values.push(value);
        }
        return values.join(';');
    }
}
Lightware.emulatorType = 'socketEmulator';
Lightware.key = '-MKL6-l0wZhGgfmsnh9M';
